import React from "react";

const NoData = ({ t }) => (
  <div className="no-data">
    <p>{t("DSS_NO_DATA")}</p>
  </div>
);
export default NoData;
